// NOTE: this patch is applied as a side effect on import, not inside a `setup()` call, because
// `Array.prototype.flatMap` is used at module-evaluation time (e.g. the typography dictionary runs
// `Object.keys(fonts).flatMap(...)` at its top level). The import graph evaluates before the entry
// body executes, so the polyfill has to be installed by the very first import of the entry points.
if (Array.prototype && typeof Array.prototype.flatMap !== 'function') {
  // eslint-disable-next-line no-extend-native, func-names
  Array.prototype.flatMap = function (callback, thisArg) {
    // `concat` flattens a single level, which matches `flatMap`'s depth-1 semantics: array results
    // are spread into the accumulator, scalar results are appended.
    return this.reduce((acc, item, index) => acc.concat(callback.call(thisArg, item, index, this)), []);
  };
}
